import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {DtoDeposit} from "./models/DtoDeposit";
import {DepositService} from "./deposit.service";


@Component({
    selector: 'app-administration-deposit',
    template: require('./deposit.component.html'),
    styles: [require('./deposit.component.css')]
})

@AutoUnsubscribe()
export class DepositComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'ZOEKOPTIES',
        buttonDefinition: [
            {
                description: 'ZOEKEN',
                clickEventType: 'search',
                isSmall: false
            },
            {
                description: 'WISSEN',
                clickEventType: 'clear',
                isSmall: false
            }
        ]
    };
    filterForm: FormGroup = this.fb.group({
        number: null
    });
    pshbConfig: PageSubheaderBarConfig = {
        title: 'KASSTORTINGEN',
        buttonDefinition: []
    };
    data: DtoDeposit[];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'depositNo',
            label: 'Stortingsnummer',
            type: 'string',
            width: '150px'
        },
        {
            key: 'depositDateTime',
            label: 'Datum',
            type: 'string',
            width: '150px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'depositAmount',
            label: 'Bedrag',
            type: 'number',
            width: '150px',
            format: '{0:c}'
        },
        {
            key: 'branch',
            label: 'Filiaal',
            type: 'string',
            width: '*'
        },
        {
            key: 'branchLocation',
            label: 'Plaats',
            type: 'string',
            width: '*'
        },
        {
            key: 'employee',
            label: 'Medewerker',
            type: 'string',
            width: '*'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ss: SharedService,
                private ds: DepositService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'administratie', isLastStep: false },
            { text: 'zoek kasstorting', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
    }

    loadData() {
        this.ds.getDepositByNumber(this.filterForm.value.number).subscribe((res: DtoDeposit[]) => {
            this.data = res;
            this.grid.showData(this.data);
        });
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        } else if (event == 'clear') {
            this.filterClear();
        }
    }

    filterClear() {
        this.filterForm.reset();
        this.grid.clearData();
    }

    onFilterEnter(event) {
        this.loadData();
    }

    onFilterEsc(event) {
        this.filterClear();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/deposit/deposit.component.ts